var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { E_AUTH_ACTION_TYPES } from './actionTypes';
var initialState = {
    isAuth: false,
    accessToken: null,
    userInfo: null,
    permissions: null,
    groups: null,
};
export var authReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case E_AUTH_ACTION_TYPES.USER_LOGIN_SUCCEEDED: {
            var accessToken = action.accessToken, userInfo = action.userInfo;
            return __assign(__assign({}, state), { accessToken: accessToken, userInfo: userInfo, isAuth: true });
        }
        case E_AUTH_ACTION_TYPES.USER_LOGOUT_SUCCEEDED: {
            return initialState;
        }
        case E_AUTH_ACTION_TYPES.FETCH_PERMISSIONS_SUCCEEDED: {
            var permissions = action.permissions;
            return __assign(__assign({}, state), { permissions: permissions });
        }
        case E_AUTH_ACTION_TYPES.FETCH_GROUP_SUCCEEDED: {
            var groups = action.groups;
            return __assign(__assign({}, state), { groups: groups });
        }
        default:
            return state;
    }
};
